import { createSlice } from '@reduxjs/toolkit';
import { Order } from '../../../app/data/models/orders/order';

export interface CustomerOrdersState {
  orders: Order[];
}

const initialState: CustomerOrdersState = {
  orders: [],
};

export const customerOrdersSlice = createSlice({
  name: 'customer/orders',
  initialState,
  reducers: {
    getCustomerOrders: (state) => {
      const ordersJson = localStorage.getItem('orders');
      if (!ordersJson) return;
      const orders = JSON.parse(ordersJson);
      state.orders = orders as Order[];
    },
  },
});

export const { getCustomerOrders } = customerOrdersSlice.actions;
